import { fromJS } from 'immutable';
import tools from '../../data/common/tools';

export default {
    setMiddlewareConnectionState: (state, connectionState) => {
        return state.setIn(['general', 'state'], connectionState);
    },
    setClientInterface: (state, clientInterface) => {
        return state.set('clientInterface', clientInterface);
    },
    setGroupId: (state, groupId) => {
        return state.set('groupId', groupId);
    },
    setAssigneeIds: (state, assigneeIds) => {
        return state.set('assigneeIds', assigneeIds);
    },
    setConfig: (state, config) => {
        return fromJS(config);
    },
    setEnums: (state, enums) => {
        return Object.keys(enums).reduce((acc, enu) => {
            return { ...acc, [enu]: tools.buildReactSelectArray(enums[enu]) };
        }, {});
    }
};



// WEBPACK FOOTER //
// ./environments/genericEnv/core.js